export enum RouterLinkIncidentParentCategory {
  Vulnerabilities = 'vulnerabilities',
  IncidentManagement = 'incidentmanagement',
}
